module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/massage-desktop@3x-7d9eea919d2f536b60442593b88c64ba.jpg";